import { Marker, SingleMapMarker } from 'components/map/Map';
import { transformToRioPosition } from 'helper/position';
import { memo, useMemo } from 'react';

import type { Hub } from 'API';

interface HubMarkerProps {
    hub: Hub;
}

// Hoisted to keep the reference stable across renders, like in VehicleMarker.
const FACTORY_ICON_NAMES = ['factory'];

/**
 * Hubs never move, so every `setGeometry`/`setIcon` UIKit performs here is wasted work.
 * Building the position object and the icon element inline meant new identities on every
 * render, and UIKit's Marker tracks both by identity — so each incoming vehicle update
 * re-pushed geometry and re-created the DOM node of every hub marker on the map.
 */
const HubComponent = ({ hub }: HubMarkerProps) => {
    const { latitude, longitude } = hub.position;

    const position = useMemo(() => transformToRioPosition({ latitude, longitude }), [latitude, longitude]);

    const icon = useMemo(
        () => (
            <SingleMapMarker
                clickable={false}
                name={hub.name}
                iconNames={FACTORY_ICON_NAMES}
                markerColor='bg-map-marker-poi'
            />
        ),
        [hub.name]
    );

    return <Marker customData={hub} position={position} icon={icon} />;
};

export default memo(HubComponent);
